
export default function ManufacturingCapabilities() {
  const capabilities = [
    {
      icon: 'ri-tools-line',
      title: 'Advanced Equipment',
      description: 'State-of-the-art machinery and technology for precision manufacturing and consistent quality output across all product lines.'
    },
    {
      icon: 'ri-team-line', 
      title: 'Skilled Workforce',
      description: 'Over 300 experienced craftsmen and technicians with expertise in traditional techniques and modern manufacturing processes.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Assurance',
      description: 'Comprehensive quality control systems ensuring every product meets international standards and client specifications.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-light text-gray-900 mb-4">
            Manufacturing Capabilities
          </h2>
          <p className="text-lg text-gray-600 font-light max-w-3xl mx-auto leading-relaxed">
            Our 100,000 m² facility combines traditional craftsmanship with cutting-edge technology
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {capabilities.map((capability, index) => (
            <div key={index} className="text-center p-8 bg-gray-50 border border-gray-100">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-gray-900 text-white">
                <i className={`${capability.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-medium text-gray-900 mb-4">
                {capability.title}
              </h3>
              <p className="text-gray-600 font-light leading-relaxed">
                {capability.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
